import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import Icon from '@jetbrains/ring-ui/components/icon'
import React from 'react'

import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs'
import {getCreatePipelineBreadcrunbs} from '../../components/common/Breadcrumbs/Breadcrumbs.utils'
import GitHubIcon from '../../svg/github.svg'

import styles from './CreatePipelineHeader.css'

function CreatePipelineHeader() {
  return (
    <div className={styles.header}>
      <div className={styles.breadcrumbs}>
        <Breadcrumbs path={getCreatePipelineBreadcrunbs()} />
      </div>
      <div className={styles.heading}>
        <H1 className={styles.title}>{'Create Pipeline'}</H1>
        <div>
          <Icon glyph={GitHubIcon} className={styles.githubIcon} />
          <span className={styles.githubText}>{'Choose repository from GitHub'}</span>
        </div>
      </div>
    </div>
  )
}

export default CreatePipelineHeader
